module.exports = {
      id: "arrow-up-usage",
      viewBox: "0 0 28.382 33.503",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#arrow-up",
      toString: function () {
        return this.url;
      }
    }